import React, { Component } from 'react';

export class BooleanTextFormatter extends Component {
  render() {
    var value = this.props.value;
    return (value && value==true)? "Yes":"No";
  }
}
